import React from 'react';
import { useSelector } from 'react-redux';
import {ListingViewConstants} from '../../common/constants';
import Icons from '../../icons';
import Select from '../Select';
import { mobileAndTabletcheck } from '../../common/util';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useModules } from '@utils/modules';

const ListingFilters = (props) => {
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const userPermissions = userView?.permissions
    const { isModuleEnabled } = useModules();
    const { selectedTab, tabCounts, onTabClick, sortOptions, onChangeSearchQuery, 
        search, sortBy, handleSorting, isSortDesc, toggleSortingDir, handleViewChange, view, type, searchText,showBottomMenu } = props;

    const renderTabs  = () => {
        if(type === ListingViewConstants.Workkard){
            return (
                <ul id="workkardTabs" className="subNav" data-test={`tabs ${selectedTab.toLowerCase()}`}>
                {
                    (userView && (userPermissions.can_create_workkard || userPermissions.can_edit_workkard || userPermissions.can_archive_workkard || userPermissions.can_change_workkard_sponsor 
                        || userPermissions.can_receive_un_assigned_workkards || userPermissions.can_close_workkard || userPermissions.can_reopen_workkard)) &&
                    <>
                        {isModuleEnabled("workkards.tab.open") && <li onClick={() => onTabClick("open")}><a href="javascript:void(0)" name="open" className={selectedTab.toLowerCase() == "open" ? "workkard_tab active" : "workkard_tab"}>Open <em className="count">({tabCounts.openCount})</em></a></li>}
                        {isModuleEnabled("workkards.tab.closed") && <li onClick={() => onTabClick("close")}><a href="javascript:void(0)" name="close" className={selectedTab.toLowerCase() == "close" ? "workkard_tab active" : "workkard_tab"}>Closed <em className="count">({tabCounts.closeCount})</em></a></li>}
                    </>
                }
                {
                    userView && userPermissions.can_receive_un_assigned_workkards && isModuleEnabled("workkards.tab.unassigned") &&
                    <li onClick={() => onTabClick("unassigned")}><a href="javascript:void(0)" name="unassigned" className={selectedTab.toLowerCase() == "unassigned" ? "workkard_tab active" : "workkard_tab"}>Unassigned <em className="count">({tabCounts.unassignedCount})</em></a></li>
                }
                {userView && isModuleEnabled("workkards.tab.following") && <li onClick={() => onTabClick("watching")}><a href="javascript:void(0)" name="watching" className={selectedTab.toLowerCase() == "watching" ? "workkard_tab active" : "workkard_tab"}>Following <em className="count">({tabCounts.watchingCount})</em></a></li>}
            </ul>
            )
        } else if(type === ListingViewConstants.Activity){
            return (
                <ul id="workkardTabs" className="subNav" data-test={`tabs ${selectedTab.toLowerCase()}`}>
                {
                    (userView && (userPermissions.can_create_activity || userPermissions.can_accept_reject_activity || userPermissions.can_mark_activity_as_in_progress || 
                        userPermissions.can_complete_activity || userPermissions.can_reopen_activity)) &&
                    <>
                        {isModuleEnabled("activities.tabs_on_landing_page.open") && <li onClick={() => onTabClick("open")}><a href="javascript:void(0)" name="open" className={selectedTab.toLowerCase() == "open" ? "workkard_tab active" : "workkard_tab"}>Open <em className="count">({tabCounts.openCount})</em></a></li>}
                        {isModuleEnabled("activities.tabs_on_landing_page.closed") && <li onClick={() => onTabClick("close")}><a href="javascript:void(0)" name="close" className={selectedTab.toLowerCase() == "close" ? "workkard_tab active" : "workkard_tab"}>Closed <em className="count">({tabCounts.closeCount})</em></a></li>}
                    </>
                }
                {
                    userView && userPermissions.can_receive_un_assigned_activities && isModuleEnabled("activities.tabs_on_landing_page.unassigned.accept_reassign_reject") &&
                    <li onClick={() => onTabClick("unassigned")}><a href="javascript:void(0)" name="unassigned" className={selectedTab.toLowerCase() == "unassigned" ? "workkard_tab active" : "workkard_tab"}>Unassigned <em className="count">({tabCounts.unassignedCount})</em></a></li>
                }
                {userView && isModuleEnabled("workkards.tab.following") && <li onClick={() => onTabClick("watching")}><a href="javascript:void(0)" name="watching" className={selectedTab.toLowerCase() == "watching" ? "workkard_tab active" : "workkard_tab"}>Following <em className="count">({tabCounts.watchingCount})</em></a></li>}
            </ul>
            )
        }
    }

    let sortTitle, sortIcon;

    if(type === ListingViewConstants.Workkard){
        sortTitle = sortBy == 1 ? (isSortDesc ? "Latest" : "Oldest") : (isSortDesc ? "Z to A" : "A to Z" )
        sortIcon = sortBy == 1 ? (isSortDesc ? "sort" : "SortbyOld") : (isSortDesc ? "decending" : "ascending")

    } else if(type === ListingViewConstants.Activity){
        sortTitle = (sortBy == 1 || sortBy == 4) ? (isSortDesc ? "Latest" : "Oldest") : (isSortDesc ?  "Z to A" : "A to Z" )
        sortIcon = (sortBy == 1 || sortBy == 4) ? (isSortDesc ? "sort" : "SortbyOld") : (isSortDesc ?  "decending" : "ascending")
    }

    return (        
        <div className="filterBlock rowFlex">
            <div className="filterLeft filterscroll">
                {renderTabs()}
            </div>
            <div className="filterRight mr">
                <ul className="alignMiddle">
                {!sessionContext.IsAuditUser && isModuleEnabled("workkards.search") && <li className="mr">
                        <div className="formGroup mr" id="workkardSearchPanel">
                            <input type="text" placeholder="Search..." className="search" value={searchText} onChange={onChangeSearchQuery} onKeyUp={search} />
                        </div>
                    </li> }
                    {selectedTab.toLowerCase() != "watching" && isModuleEnabled("workkards.sorting") &&
                    <>
                        <li data-test={`listingSortBy ${sortBy == 1 ? "createdDate" : "workkardNumber"}`}>
                            <div className="formGroup alignMiddle">
                                <label className="mrNone">Sort by</label>
                                <Select
                                    options={sortOptions}
                                    selected={sortBy}
                                    onSelect={(value) => handleSorting(value)}
                                    openOnClick={true}
                                    iconName="downArrow"
                                    styleClass="ml"
                                    isOpenRight={true}
                                />
                            </div>
                        </li>
                        <li className="sorting" data-test={`listingSort ${sortTitle}`}>
                            <a className="h__16 quickTooltip-bottom" data-quicktooltip={mobileAndTabletcheck() ? "": sortTitle} href="#" onClick={() =>{ mobileAndTabletcheck() ? showBottomMenu(true) : toggleSortingDir()}}>
                                <Icons name={sortIcon} />
                            </a>
                        </li>
                    </>}
                    <li className="rowFlex ml toggleView" id="divToggleView">
                        {isModuleEnabled(type === ListingViewConstants.Activity ? "activities.activity_details_view.card" : "workkards.card_view") && <span className="cardViewIcon">
                            <a name="cardView" href="javascript:void(0);" tmpl="WorkkardCardViewSubTemplate" data-quicktooltip="Card view" className="quickTooltip-bottom h__16" onClick={() => handleViewChange(ListingViewConstants.CardView)}>
                                <Icons name="reorder" className={`icon thumbView ${view == ListingViewConstants.CardView ? "active" : ""}`} />
                            </a>
                        </span>}
                        {isModuleEnabled(type === ListingViewConstants.Activity ? "activities.activity_details_view.list" : "workkards.list_view") && <a name="gridView" href="javascript:void(0);" tmpl="workkardGridViewTmpl" data-quicktooltip="List view" className="quickTooltip-bottom h__16 active" onClick={() => handleViewChange(ListingViewConstants.ListView)}>
                            <Icons name="grid" className={`icon thumbView ${view == ListingViewConstants.ListView ? "active" : ""} `} />
                        </a>}
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ListingFilters;